import React from 'react'
import { func } from 'prop-types'
import { Row } from '@gympass/yoga'
import Container from '@components/Container'
import useContact from '@hooks/useContact'

import Form from '../../components/Form'
import Card from '../../components/OfferCard'

import * as Style from './Main.style'

export default function Main({ handleForm, onPrevious }) {
  const { contact } = useContact()

  return (
    <Style.MainWrapper>
      <Container>
        <Row>
          <Style.FormColumn xxs={12} xl={7}>
            <Form onSubmit={handleForm} onPrevious={onPrevious} />
          </Style.FormColumn>

          <Style.CardColumn hide={['xxs', 'xs', 'sm', 'md', 'lg']} xl={5}>
            <Card contact={contact} />
          </Style.CardColumn>
        </Row>
      </Container>
    </Style.MainWrapper>
  )
}

Main.propTypes = {
  handleForm: func.isRequired,
  onPrevious: func.isRequired,
}
